import script from "./TabsSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./TabsSelector.vue?vue&type=script&setup=true&lang=js"

import "./TabsSelector.vue?vue&type=style&index=0&id=d1fb344a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1fb344a"]])

export default __exports__